'use strict';

// In-memory session: holds the decrypted live keys while the vault is unlocked.
// NOTE: JavaScript can't truly zero memory (GC), so lock() drops all references —
// the strongest hygiene available client-side. Keys are NEVER persisted in plaintext.

let state = { email: null, did: null, keys: null, mnemonic: null };
const subscribers = new Set();

function notify() {
  for (const fn of subscribers) { try { fn(state); } catch (_) { /* ignore */ } }
}

module.exports = {
  set(patch) { state = Object.assign({}, state, patch); notify(); return state; },
  get() { return state; },
  isUnlocked() { return !!state.keys; },
  // Lock: wipe key material + mnemonic, keep the email so we can offer a quick re-unlock.
  lock() { state = { email: state.email, did: state.did, keys: null, mnemonic: null }; notify(); },
  // Clear: full sign-out (forget everything in memory).
  clear() { state = { email: null, did: null, keys: null, mnemonic: null }; notify(); },
  subscribe(fn) { subscribers.add(fn); return () => subscribers.delete(fn); },
};
